import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './AdminUserSettings.scss';

import { updateUserSettings } from '../../../../Actions/UserActions';
import { getSettings, getName } from '../../../../Helpers/user_helpers';
import SelectOption from '../../../General/SelectOption';

const MATCHING_PRIORITY_OPTIONS = [
  { value: 'normal', label: 'Normal Priority', sublabel: 'Pins added by this user go through the default matching queue' },
  { value: 'high', label: 'High Priority', sublabel: 'Pins added by this user will be prioritized for product matching and display in Latest Finds' },
  { value: 'low', label: 'Low Priority', sublabel: 'Pins added by this user will be prioritized after the normal and high priority queues' }
];

const AdminUserSettings = props => {
  const { user } = props;
  const { isLowPriorityForMatching, isHighPriorityForMatching, trustedByCount } = getSettings(user);

  const currentPriority = isHighPriorityForMatching ? 'high' : isLowPriorityForMatching ? 'low' : 'normal';
  const [isUpdating, setIsUpdating] = useState(false);
  const updateMatchingPriority = async newPriority => {
    if (isUpdating) return window.ALERT.warn('Still saving...');
    setIsUpdating(true);
    await props.updateUserSettings({
      isHighPriorityForMatching: newPriority === 'high',
      isLowPriorityForMatching: newPriority === 'low'
    });
    window.ALERT.success(`${getName(user)} is now ${newPriority} priority for product matching`);
    setIsUpdating(false);
  };

  const adjustTrustedBy = () => {
    const trustCountAdjustmentNew = window.prompt('Enter the new "Trusted By" adjustment. For example, +1000 or -50');
    if (!trustCountAdjustmentNew) return;
    const newCount = parseInt(trustCountAdjustmentNew);
    if (isNaN(newCount)) return window.ALERT.warn('Invalid adjustment');
    props
      .updateUserSettings({ trustCountAdjustment: newCount })
      .then(() =>
        window.ALERT.success(`Trusted By count adjusted to ${newCount}. You can check their shop to verify the change.`, { timeout: 10_000 })
      )
      .catch(() => window.ALERT.error('Error adjusting Trusted By count'));
  };

  return (
    <>
      <div className='admin-user-settings-container settings-section'>
        <div className='settings-section-title'>Product Matching Priority</div>
        <div className='switch-container'>
          <Select
            options={MATCHING_PRIORITY_OPTIONS}
            value={MATCHING_PRIORITY_OPTIONS.find(o => o.value === currentPriority)}
            onChange={selected => {
              updateMatchingPriority(selected.value);
            }}
            components={{ Option: SelectOption }}
            styles={{
              singleValue: provided => ({
                ...provided,
                fontWeight: 'bold',
                fontSize: '14px'
              })
            }}
          />
        </div>
      </div>
      <div className='admin-user-settings-container settings-section'>
        <div className='settings-section-title'>Trusted By Adjustment</div>
        <div className='settings-section-subtitle'>Adjust the "Trusted By" count for this user, only use if absolutely necessary.</div>
        {/* <div className='settings-section-actions'> */}
        <button onClick={adjustTrustedBy} className='settings-button'>
          Adjust Trusted By
        </button>
        {/* </div> */}
      </div>
    </>
  );
};

AdminUserSettings.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  updateUserSettings
})(AdminUserSettings);
